import script from "./theme-switcher.vue?vue&type=script&setup=true&lang=js"
export * from "./theme-switcher.vue?vue&type=script&setup=true&lang=js"

import "./theme-switcher.vue?vue&type=style&index=0&id=62dda94c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62dda94c"]])

export default __exports__